module.exports = __webpack_public_path__ + "static/media/banana-ltc-bnb.4823bc64.svg";